import React, { useMemo } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import classNames from 'classnames';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import Icon from '../../../baseComponents/gui/icon/Icon';
import { gamesList } from '../../../../constants/copyright';
import { useTranslation } from '../../../../translations';

const GamesItem = React.forwardRef(function GamesItem(
  { index, name, timeout, gameData, isAvailable, onClick, energy, completedGames, rating, section },
  ref,
) {
  const { list } = gamesList;

  const { t } = useTranslation();

  const isRatingSection = useMemo(() => section === 'rating', [section]);

  const isWhite = Object.values(list).some(({ apiName, isWhite }) => apiName === name && isWhite);
  const isVisibleInfo = Object.values(list).some(({ apiName, isVisibleInfo }) => apiName === name && isVisibleInfo);
  const ratingGameCondition = useMemo(
    () =>
      Object.values(list)
        ?.reduce((acc, { isRating, apiName }) => {
          if (isRating) acc.push(apiName);
          return acc;
        }, [])
        .includes(name),
    [name],
  );

  const levelCondition = useMemo(
    () => isAvailable && !isRatingSection && !rating,
    [isAvailable, isRatingSection, rating],
  );

  const ratingLeftCondition = useMemo(
    () => isAvailable && !isRatingSection && ratingGameCondition && rating,
    [isAvailable, isRatingSection, ratingGameCondition, rating],
  );

  return (
    <div
      className={classNames('games__item', `games__item_${index}`, {
        [gameData.className]: gameData.className,
        games__item_disabled: !isAvailable,
        games__item_white: isWhite,
      })}
      ref={ref}
      data-tutor-id={`game-${name}`}
      onClick={onClick}
    >
      {!isRatingSection && ratingGameCondition && (
        <CustomButton className={'games__item-box'}>
          <Icon name={'buttons/gift-icon'} />
        </CustomButton>
      )}
      <div className='games__item-image'>
        <picture>
          {gameData?.imageT ? (
            <>
              <source srcSet={gameData?.imageM} media={'(max-width:767px)'} />
              <source srcSet={gameData?.imageT} media={'(min-width:768px) and (max-width:1023px)'} />
            </>
          ) : (
            <source srcSet={gameData?.imageM} media={'(max-width:1023px)'} />
          )}
          <img src={gameData?.image} alt={name} />
        </picture>
      </div>
      <div className={`games__item-footer ${!isAvailable ? 'games__item-footer_closed' : ''}`}>
        <div className={'games__item-title'}>
          {safeHTML(t(gameData?.title))}
          {isVisibleInfo && (
            <>
              {levelCondition && (
                <span>
                  {t('gamesList.level')} {completedGames + 1}
                </span>
              )}

              {ratingLeftCondition && (
                <span>
                  {t('gamesList.rating')} {rating}
                </span>
              )}
            </>
          )}
        </div>
        {isRatingSection && rating ? (
          <div className={'games__item-rating'}>{`${rating} ${t('gamesList.place')}`}</div>
        ) : !isAvailable ? (
          <div className={'games__item-timer'}>{t('gamesList.close')}</div>
        ) : (
          energy && (
            <CustomButton
              text={'gamesList.play'}
              icon={'energy-b'}
              count={energy}
              className={'custom-button custom-button_play games__item-button'}
            />
          )
        )}
      </div>
    </div>
  );
});
export default GamesItem;
GamesItem.propTypes = {};
